// extracted by mini-css-extract-plugin
export default {"sidebar":"section-sidebar_sidebar__3IlAA","backdrop":"section-sidebar_backdrop__bSjQi","menu":"section-sidebar_menu__LIB1d","spacer":"section-sidebar_spacer__GdFdg"};